import React from "react";

export const Footer = (props) => {
  return (
    <div>
      <div id="footer">
        <div className="container text-center">
          <p>
            {props.data?.copyright}
          </p>
        </div>
      </div>
    </div>
  );
};
